import { c as _c } from "react/compiler-runtime";
import { MainFilterInterface } from 'modules/main/types/main-filter-interface';
import { MainEventsApiInterface, MainLeadsInterface, MainRevenueInterface } from 'modules/main/types/main-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { LimitType } from 'shared/types/pagination-interface';
import useSWR from 'swr';
import { useControlledSwr } from '@systemeio/util';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
export const MAIN_API = '/api/dashboard/customer/main-dashboard';
const EVENTS_LIMIT: LimitType = 25;
export function useMain(filter) {
  const $ = _c(23);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: leadsFetcher
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: eventsFetcher
  } = useFetch(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.get
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    fetcher: revenueFetcher
  } = useFetch(t2);
  const filterApi = `${filter.dateSince !== null ? `&filter[dateSince]=${filter.dateSince}` : ""}${filter.dateTill !== null ? `&filter[dateTill]=${filter.dateTill}` : ""}`;
  let t3;
  if ($[3] !== filter.dateSince || $[4] !== filter.dateTill || $[5] !== filterApi || $[6] !== user) {
    t3 = () => {
      if (user && filter.dateTill !== null && filter.dateSince !== null) {
        return [`${MAIN_API}/leads?${filterApi}`, user];
      }
      return null;
    };
    $[3] = filter.dateSince;
    $[4] = filter.dateTill;
    $[5] = filterApi;
    $[6] = user;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== leadsFetcher) {
    t4 = t5 => {
      const [url] = t5;
      return leadsFetcher(url);
    };
    $[8] = leadsFetcher;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    data: leads
  } = useSWR(t3, t4);
  let t5;
  if ($[10] !== user) {
    t5 = () => {
      if (user) {
        return [`${MAIN_API}/events?pagination[order]=next&pagination[limit]=${EVENTS_LIMIT}`, user, RequestModuleEnum.Contacts];
      }
      return null;
    };
    $[10] = user;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const {
    data: events
  } = useControlledSwr(t5, eventsFetcher);
  let t6;
  if ($[12] !== filter.dateSince || $[13] !== filter.dateTill || $[14] !== filterApi || $[15] !== user) {
    t6 = () => {
      if (user && filter.dateTill !== null && filter.dateSince !== null) {
        return [`${MAIN_API}/revenue?${filterApi}`, user];
      }
      return null;
    };
    $[12] = filter.dateSince;
    $[13] = filter.dateTill;
    $[14] = filterApi;
    $[15] = user;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== revenueFetcher) {
    t7 = t8 => {
      const [url_0] = t8;
      return revenueFetcher(url_0);
    };
    $[17] = revenueFetcher;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const {
    data: revenue
  } = useSWR(t6, t7);
  let t8;
  if ($[19] !== events || $[20] !== leads || $[21] !== revenue) {
    t8 = {
      leads,
      events,
      revenue
    };
    $[19] = events;
    $[20] = leads;
    $[21] = revenue;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}